module.exports = __webpack_public_path__ + "static/media/Pod_Sv_kopeckemI.11d7fdca.md";